/** Campo de parcela da tabela de parcelas */
import React, { Component } from "react";
import { connect } from "react-redux";

import CurrencyField from "../../CurrencyField";
import PropTypes from "prop-types";

class ParcelaField extends Component {
  /** Propriedades que esse componente recebe */
  static propTypes = {
    valorParcela: PropTypes.any,
    changeFunction: PropTypes.func,
    numParcela: PropTypes.number,
    valorAcordo: PropTypes.number,
    acordo: PropTypes.string
  };

  state = {
    value: this.props.valorParcela,
    error: false
  };

  UNSAFE_componentWillReceiveProps(props) {
    /**
     * Componente props update (Caso o usuário altere o valor do acordo, ou da parcela
     * esse evento é chamado).
     */

    if (this.props.valorParcela != props.valorParcela) {
      this.setState({
        value: props.valorParcela,
        error: false
      });
      return;
    }
    /** Verifica se o valor foi alterado pelo usuário, caso sim, altera o valor do estado (valor parcela) */
    let parcelas = props.parcelas.parcelas;

    if (parcelas) {
      /** Verifica se o valor dessa parcela foi alterado */
      if (parcelas[this.props.numParcela]) {
        // Se sim, verifica se é o mesmo valor do atual, caso seja, apenas ignora.
        let value = parcelas[this.props.numParcela].value;

        if (value != this.state.value) {
          if (isNaN(value) || value <= 0) {
            value = 0;
          }
          this.setState({
            value: value
          });
        }
      }
    }
  }

  handleChange = (value, numParcela) => {
    this.props.changeFunction(value, numParcela);

    this.setState({
      value
    });
  };

  /** Quando o componente for criado, atualiza o estado */
  componentDidMount() {
    this.setState({
      value: this.props.valorParcela
    });
  }

  render() {
    return (
      <CurrencyField
        onChangeEvent={value => this.handleChange(value, this.props.numParcela)}
        value={this.state.value}
        innitialValue={parseFloat(this.props.value)}
        name={this.props.name}
        id={this.props.name}
        className={`ant-input ${this.state.error ? "input-error" : ""}`}
      />
    );
  }
}

export default connect(state => ({
  parcelas: state.acordo
}))(ParcelaField);



// WEBPACK FOOTER //
// ./src/components/Acordo/ParcelaField/index.js